var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('m-input',{staticClass:"search-form-field",attrs:{"nolabel":"","placeholder":_vm.$t('search.returnreason')},model:{value:(_vm.search.RETURNVARIABLENAME),callback:function ($$v) {_vm.$set(_vm.search, "RETURNVARIABLENAME", $$v)},expression:"search.RETURNVARIABLENAME"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }